import React, {Fragment} from 'react';
import '../UserManagePageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import BodyManageAccount from "root/Management/BodyManageAccount";

const ManagePageBody = (props) =>
{
    return (
        <Fragment>
            <PageBodyWrapper title='Manage Your Information'>
            <div className='manage-grid-rows'>
                <BodyManageAccount/>
            </div>
            </PageBodyWrapper>
        </Fragment>
    )
}

export default ManagePageBody;
